import React, { useState, useEffect } from "react";
import dayjs from "dayjs";
import { DAILY_HOLDING_ENDPOINT } from "../config/urls";
import AppTable from "../common/app-table";

const tableColumns = [
  { id: "client_code",        label: "Client Code",    render: (h) => h.client.client_code  },
  { id: "client_name",        label: "Name",           render: (h) => h.client.client_name  },
  { id: "phone_no",           label: "Phone Number",   render: (h) => h.client.phone_no     },
  { id: "total_portfolio_val", label: "Total Portfolio" },
  { id: "asset_precent",      label: "Assets %"        },
  { id: "market_val",         label: "Market Value"    },
  { id: "gain_loss",          label: "Gain/Loss"       },
  { id: "asset_class",        label: "Asset Class"     },
  { id: "symbol_code",        label: "Symbol of Code"  },
  { id: "symbol_name",        label: "Symbol of Name"  },
  { id: "strategy_id",        label: "Strategy ID"     },
  { id: "strategy_name",      label: "Strategy name"   },
  { id: "holding_date",       label: "Holding Date"    },
  { id: "upload_date",        label: "Uploaded On",    render: (h) => h.file.upload_date    },
];

export default function HoldingsTable({ searchInput, refreshKey, dateInput, assetClass, gainLoss, }) {
  const [rowCount, setRowCount]     = useState(0);
  const [holdings, setHoldings]     = useState([]);
  const [loading, setLoading]       = useState(false);
  const [controller, setController] = useState({ page: 0, rowsPerPage: 20 });

  const URL = process.env.NODE_ENV === "production" ? "api" : "http://localhost:8000/api";

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const searchURL  = searchInput ? `&search_value=${searchInput}` : "";
        const searchDateURL = dateInput ? `&search_date=${dayjs(dateInput).format("YYYY-MM-DD")}` : "";
        const assetURL = assetClass ? `&asset_class=${assetClass}` : "";
        const gainLossURL = gainLoss ? `&gain_loss_status=${gainLoss}` : "";
        const user   = JSON.parse(localStorage.getItem("user"));
        const tenant = localStorage.getItem("tenant");

        const response = await fetch(
          `${DAILY_HOLDING_ENDPOINT}?user_id=${user.id}&limit=${controller.rowsPerPage}&offset=${
            controller.page * controller.rowsPerPage
          }${searchURL}${searchDateURL}${assetURL}${gainLossURL}`,
          { headers: { "Content-Type": "application/json", "X-Tenant-Id": tenant } }
        );
        if (!response.ok) throw new Error("Failed to fetch data");
        const jsonData = await response.json();
        setHoldings(jsonData.results);
        setRowCount(jsonData.count);
      } catch (error) {
        console.error("Error fetching data:", error.message);
        setHoldings([]);
        setRowCount(0);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [controller, searchInput, refreshKey, dateInput, assetClass, gainLoss,]);

  const handlePageChange        = (event, newPage) => setController((prev) => ({ ...prev, page: newPage }));
  const handleChangeRowsPerPage = (event) => setController({ page: 0, rowsPerPage: parseInt(event.target.value, 10) });

  return (
    <AppTable
      columns={tableColumns}
      rows={holdings}
      rowKey={(holding, index) => index}
      loading={loading}
      emptyMessage="No match found"
      maxHeight={530}
      count={rowCount}
      page={controller.page}
      rowsPerPage={controller.rowsPerPage}
      rowsPerPageOptions={[20, 50, 100]}
      onPageChange={handlePageChange}
      onRowsPerPageChange={handleChangeRowsPerPage}
    />
  );
}